import React from 'react';
import PropTypes from 'prop-types';

const ProductUnitDetails = ({ detailStr }) => (
  <div
    className="pr-checkout-item__details"
    style={{
      color: '#6E707C',
      fontSize: '1rem',
      fontWeight: '500',
      margin: '0.5rem 0 0 12px',
      maxWidth: '100%',
    }}
  >
    {detailStr}
  </div>
);

ProductUnitDetails.propTypes = {
  detailStr: PropTypes.string.isRequired,
};

export default ProductUnitDetails;
